import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Banner from '../views/Banner.vue'
import Umum from '../views/Umum.vue'
import Pelaku from '../views/Pelaku.vue'
import Produk from '../views/Produk.vue'
import Kategori from '../views/Kategori.vue'
import Pengguna from '../views/Pengguna.vue'
import Level from '../views/Level.vue'
import Login from '../views/Login.vue'
import Registrasi from '../views/Registrasi.vue'

function loggedInRedirectDashboard(to, from, next) {
    if (localStorage.token) {
      next('/');
    } else {
      next();
    }
}
  
function isLoggedIn(to, from, next) {
    if (localStorage.token) {
        const jwtPayload = JSON.parse(window.atob(localStorage.token.split('.')[1]))
        if (jwtPayload.exp < Date.now() / 1000) {
            localStorage.removeItem('token');
            localStorage.removeItem('profile');
            next('/login');
        }
      next();
    } else {
      next('/login');
    }
}

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: isLoggedIn
    },
    {
        path: '/umum',
        name: 'Umum',
        component: Umum
    },
    {
        path: '/banner',
        name: 'Banner',
        component: Banner
    },
    {
        path: '/pelaku',
        name: 'Pelaku',
        component: Pelaku
    },
    {
        path: '/produk',
        name: 'Produk',
        component: Produk
    },
    {
        path: '/kategori',
        name: 'Kategori',
        component: Kategori,
        beforeEnter: isLoggedIn
    },
    {
        path: '/pengguna',
        name: 'Pengguna',
        component: Pengguna,
        beforeEnter: isLoggedIn
    },
    {
        path: '/level',
        name: 'Level',
        component: Level,
        beforeEnter: isLoggedIn
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        beforeEnter: loggedInRedirectDashboard,
    },
    {
        path: '/registrasi',
        name: 'Registrasi',
        component: Registrasi,
        beforeEnter: loggedInRedirectDashboard,
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
  })
  
  export default router